import { Box, Card, CardContent } from "@mui/material";
import {
  XAxis,
  YAxis,
  ResponsiveContainer,
  BarChart as ReBarChart,
  Bar,
  Label,
  Tooltip,
} from "recharts";

import { Typography } from "components/Typography";
import { formatToNaira } from "utils/formatCurrency";

import { DATA_SOURCE_COLOR } from "../Legend";
import { Y_AXIS_TYPES, Y_AXIS_OPTIONS } from "../YAxisFilter";

const Y_AXIS_DATA_KEY = {
  [Y_AXIS_TYPES.AMOUNT]: "total",
  [Y_AXIS_TYPES.COUNT]: "count",
};

export const BarChart = ({ source, yAxisKey, data }) => {
  const barColor = DATA_SOURCE_COLOR[source];
  const yAxisDataKey = Y_AXIS_DATA_KEY[yAxisKey];
  const yAxisLabel = Y_AXIS_OPTIONS[yAxisKey];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ReBarChart width={600} height={300} data={data}>
        <XAxis dataKey="name" />
        <YAxis>
          <Label
            value={yAxisLabel}
            position="insideLeft"
            angle={-90}
            offset={10}
          />
        </YAxis>
        <Tooltip cursor={false} content={<CustomTooltip />} />
        <Bar dataKey={yAxisDataKey} barSize={30} fill={barColor} />
      </ReBarChart>
    </ResponsiveContainer>
  );
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const item = payload[0].payload;

    return (
      <Card>
        <CardContent>
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography
              variant="loginHeading"
              component="h5"
              style={{ fontSize: "16px" }}
            >
              {item.name}
            </Typography>
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="loginLabel">Count:</Typography>
              <Typography variant="loginfooter">{item.count}</Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="loginLabel">Amount:</Typography>
              <Typography variant="body2" color="text.secondary">
                {formatToNaira(item.total)}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  }

  return null;
};
